import { type ReactNode } from "react";

// Generic centered dialog: a dimmed overlay that closes on click, an inner
// content card that swallows clicks (so clicking the card doesn't close it), and
// a × button. The dialog's heading and body are passed as children. Extracted
// from the two App modals (What-is-JSONL / Disclaimer) so both share one shell.
export function Modal({
  onClose,
  children,
}: {
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}

export default Modal;
